import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { InviteFriendsModal } from "@/components/InviteFriendsModal";
import { useCurrentUser } from "@/hooks/useCurrentUser";

export const Route = createFileRoute("/convidar")({
  head: () => ({
    meta: [
      { title: "Convide amigos — Viny Club" },
      { name: "description", content: "Convide amigos para o Viny Club e ganhe XP a cada cadastro." },
    ],
  }),
  component: Convidar,
});

function Convidar() {
  const [open, setOpen] = useState(true);
  const { loading, isAuthenticated } = useCurrentUser();
  const navigate = useNavigate();
  useEffect(() => {
    if (!loading && !isAuthenticated) navigate({ to: "/auth", replace: true });
  }, [loading, isAuthenticated, navigate]);
  return (
    <div className="min-h-screen bg-background">
      <InviteFriendsModal
        open={open}
        onOpenChange={(v) => {
          setOpen(v);
          if (!v) navigate({ to: "/explore" });
        }}
      />
    </div>
  );
}
